<template>
  <v-select
    :items="values"
    label="Loja Aberta"
    item-text="text"
    item-value="value"
    v-model="valueSelecionado"
  >
    <template v-slot:item="{ item }">
      <v-icon
        v-if="item.color" 
        :color="item.color"
      >
        {{ item.icon }}
      </v-icon>
      <span class="ml-1">{{ item.text }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
   name: 'FiltroLojaAberta',
  data() {
    return {
      values: [
        {
          text: 'Todos as lojas',
          value: null,
          icon: false
        },
        {
          text: 'Abertas',
          value: 0,
          icon: 'lock_open',
          color: 'green'
        },
        {
          text: 'Fechadas',
          value: 1,
          icon: 'lock',
          color: 'gray darken-3'
        },
        {
          text: 'Fechadas no horário de funcionamento',
          value: 2,
          icon: 'lock',
          color: 'red'
        },
        {
          text: 'Abertas fora do horário de funcionamento',
          value: 3,
          icon: 'lock_open',
          color: 'orange'
        },
        {
          text: 'Fechadas temporariamente',
          value: 4,
          icon: 'lock_clock',
          color: 'gray darken-3'
        }
      ],
      valueSelecionado: null
    }
  },
  watch: {
    valueSelecionado() {
      this.emitirValueSelecionado()
    }
  },
  mounted() {
    this.emitirValueSelecionado()
  },
  methods: {
    emitirValueSelecionado() {
      this.$emit('filtrar-loja-aberta', {
        loja_aberta: this.valueSelecionado
      })
    }
  }
}
</script>
